import { render, staticRenderFns } from "./nv-tag.vue?vue&type=template&id=60e9a2ca&"
import script from "./nv-tag.vue?vue&type=script&lang=ts&"
export * from "./nv-tag.vue?vue&type=script&lang=ts&"
import style0 from "./nv-tag.vue?vue&type=style&index=0&id=60e9a2ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports